const AWSXray = {
  getSegment: () => AWSXray,
  addNewSubsegment: () => {},
  addAnnotation: () => {},
  close: () => {},
}

export default AWSXray
